import React, { useContext } from "react";
import "./PageTwelve.scss";
import { BuildingsContext } from "../../../bContext";

function PageTwelve() {
  const { switchToEnglish } = useContext(BuildingsContext);
  return (
    <>
      <div className="pageTwelve">
        {/* <div className="menu-pg4"></div> */}

        <div>
          <div className="speech-bubble5">
            {switchToEnglish === false ? (
              <p className="first">Okno możemy zamknąć przyciskiem "X".</p>
            ) : (
              <p className="first">The window can be closed with "X" button.</p>
            )}
            <div className="inner-triangle-right5"></div>
          </div>
          {/* <div className="speech-bubble6">
            <p className="first">
              ...natomiast jego nazwa wyświetli się w tym okienku.
            </p>
            <div className="inner-triangle-right6"></div>
          </div> */}
          {/* <div className="menu-pg5"></div>  */}

          <div className="modal-header-ins"></div>
          <div className="modalbtn"></div>
          <div className="defaultbtn"></div>
        </div>
      </div>
    </>
  );
}

export default PageTwelve;
